export enum ReportValuesSource {
  Unknown,
  UsedValues,
  FutureValues
}



// WEBPACK FOOTER //
// ./src/app/report/enums/report-values-source.ts